export default __webpack_public_path__ + "static/HEYCUTIE_BLUE-2cb039be4156c49852b411b1f2ddcc52.png";